import React, { useEffect, useState } from "react";
import { X, TrendingUp } from "lucide-react";

const API_BASE = process.env.REACT_APP_API_BASE || "http://localhost:8000";

function money(n) {
  if (n == null) return "—";
  return typeof n === "number" ? `£${n.toLocaleString()}` : String(n);
}

export default function MemberSalaryDrawer({ member, onClose }) {
  const [history, setHistory] = useState([]);
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    if (!member?.id) return;
    const token = localStorage.getItem("token");
    setLoading(true);
    fetch(`${API_BASE}/api/manager/payroll/employee/${member.id}/history`, {
      headers: { Authorization: `Bearer ${token}` },
    })
      .then(r => r.json())
      .then(d => setHistory(Array.isArray(d) ? d : d?.history || []))
      .catch(() => setHistory([]))
      .finally(() => setLoading(false));
  }, [member?.id]);

  if (!member) return null;

  return (
    <div className="fixed inset-0 z-[10060]">
      <div className="absolute inset-0 bg-black/70 backdrop-blur-sm" onClick={onClose} />

      <div className="absolute right-0 top-0 h-full w-full sm:w-[400px] bg-[#0d0d0d] border-l border-[#00ff90]/20 shadow-[-20px_0_60px_#00ff9011] text-white flex flex-col">

        <div className="flex items-center justify-between px-5 py-4 border-b border-white/5">
          <div>
            <p className="font-semibold text-white">{member.name}</p>
            <p className="text-xs text-[#00ff90]/50 mt-0.5">{member.role}</p>
          </div>
          <button onClick={onClose}
            className="w-8 h-8 rounded-lg border border-white/10 bg-white/5 flex items-center justify-center text-white/40 hover:text-white transition-colors">
            <X size={14} />
          </button>
        </div>

        <div className="flex-1 overflow-y-auto p-5 space-y-4">

          {/* Current salary */}
          {member.annualSalary && (
            <div className="rounded-xl border border-[#00ff90]/15 bg-[#00ff90]/5 p-4">
              <p className="text-xs text-[#00ff90]/50 uppercase tracking-wider mb-2">Current Annual Salary</p>
              <p className="text-2xl font-bold text-[#00ff90]">{money(member.annualSalary)}</p>
              {member.nextAppraisal && (
                <p className="text-xs text-white/30 mt-1">Next appraisal: {member.nextAppraisal}</p>
              )}
            </div>
          )}

          {/* Increment history */}
          <div className="rounded-xl border border-white/5 bg-white/3 p-4">
            <p className="text-xs text-[#00ff90]/50 uppercase tracking-wider mb-3">Increment History</p>

            {loading ? (
              <div className="space-y-2">{[1,2,3].map(i => <div key={i} className="h-14 bg-white/5 rounded-lg animate-pulse" />)}</div>
            ) : history.length === 0 ? (
              <p className="text-white/20 text-sm italic">No increment records found.</p>
            ) : (
              <div className="space-y-2">
                {history.map((h, i) => {
                  const diff = h.to && h.from ? h.to - h.from : null;
                  return (
                    <div key={i} className="rounded-lg border border-white/5 bg-black/30 p-3">
                      <div className="flex items-start justify-between gap-2">
                        <div>
                          <div className="flex items-center gap-2">
                            <span className="text-xs text-white/40">{money(h.from)}</span>
                            <span className="text-white/20 text-xs">→</span>
                            <span className="text-xs text-white/70 font-medium">{money(h.to)}</span>
                            {diff != null && (
                              <span className="text-xs text-[#00ff90] bg-[#00ff90]/10 border border-[#00ff90]/20 px-1.5 py-0.5 rounded-full">
                                +{money(diff)}
                              </span>
                            )}
                          </div>
                          {h.reason && <p className="text-xs text-white/25 mt-0.5">{h.reason}</p>}
                        </div>
                        <div className="text-right shrink-0">
                          {h.deltaPct != null && (
                            <div className="flex items-center gap-1 text-[#00ff90] justify-end">
                              <TrendingUp size={11} />
                              <span className="text-xs font-bold">+{Number(h.deltaPct).toFixed(1)}%</span>
                            </div>
                          )}
                          <p className="text-xs text-white/20">{h.date}</p>
                        </div>
                      </div>
                    </div>
                  );
                })}
              </div>
            )}
          </div>

          <div className="rounded-xl border border-white/5 bg-white/3 p-4">
            <p className="text-xs text-white/20 text-center">Salary details only — no personal information shown</p>
          </div>
        </div>
      </div>
    </div>
  );
}